// A theme's picture the way the backend keeps it (models/TemplateTheme.js): A4 at
// 150 dpi, cropped to cover the page as the PDF draws it, and a thumbnail 480 px
// wide for the customer to pick by. Made here, so the backend needs no image library.

const A4_150_DPI = { landscape: [1754, 1240], portrait: [1240, 1754] };
const THUMBNAIL_WIDTH = 480;
// What the backend takes (utils/templateTheme.js)
const MAX_IMAGE_BYTES = 2 * 1024 * 1024;
const MAX_THUMBNAIL_BYTES = 300 * 1024;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Зургийг уншиж чадсангүй. JPEG эсвэл PNG файл сонгоно уу."));
    };
    img.src = url;
  });

// Draws the picture over the whole canvas, its middle kept and its overflow cut off.
// White underneath, as paper is where a PNG is see-through.
const drawCover = (source, width, height) => {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, width, height);
  const sourceWidth = source.naturalWidth || source.width;
  const sourceHeight = source.naturalHeight || source.height;
  const scale = Math.max(width / sourceWidth, height / sourceHeight);
  const drawnWidth = sourceWidth * scale;
  const drawnHeight = sourceHeight * scale;
  context.imageSmoothingQuality = "high";
  context.drawImage(source, (width - drawnWidth) / 2, (height - drawnHeight) / 2, drawnWidth, drawnHeight);
  return canvas;
};

const toJpeg = (canvas, quality) =>
  new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));

// The best quality that is still small enough
const smallJpeg = async (canvas, maxBytes) => {
  for (const quality of [0.88, 0.8, 0.7, 0.6, 0.5]) {
    const blob = await toJpeg(canvas, quality);
    if (blob && blob.size <= maxBytes) return blob;
  }
  throw new Error("Зураг хэт нарийн ширхэгтэй байна. Өөр зураг сонгоно уу.");
};

// { image, thumbnail } as JPEG blobs for the file and the page's orientation
export const prepareThemeImage = async (file, orientation) => {
  const img = await loadImage(file);
  const [width, height] = A4_150_DPI[orientation] || A4_150_DPI.landscape;
  const page = drawCover(img, width, height);
  const thumbnail = drawCover(page, THUMBNAIL_WIDTH, Math.round((THUMBNAIL_WIDTH * height) / width));
  return {
    image: await smallJpeg(page, MAX_IMAGE_BYTES),
    thumbnail: await smallJpeg(thumbnail, MAX_THUMBNAIL_BYTES),
  };
};
